import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconImportExportComponent } from "./med-icon-import-export.component";

@NgModule({
  declarations: [
    MedIconImportExportComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconImportExportComponent,
  ],
})
export class MedIconImportExportModule { }
